import * as _ from 'lodash';
import * as moment from 'moment';
import * as Mutations from './mutations';
import {BillingInfoService} from '../../../common/services/settings/billing-info.service';
import {BILLING_TYPES} from '../../../constants/billing-types';

export const BillingInfoModule = {
    state: {
        billingList: null,
        billingOptionId: null,
        billingOption: null,
        invoices: null
    },

    mutations: {
        [Mutations.SET_BILLING_LIST] (state, billingList) {
            state.billingList = billingList;
        },

        [Mutations.SET_BILLING_OPTION_ID] (state, billingOptionId) {
            state.billingOptionId = billingOptionId;
        },

        [Mutations.SET_BILLING_OPTION] (state, billingOption) {
            state.billingOption = billingOption;
        },

        [Mutations.SET_BILLING_INVOICES] (state, invoicesList) {
            state.invoices = invoicesList;
        }
    },

    actions: {
        async getBillingInfo(context) {
            const { data } = await BillingInfoService.getSchoolBillingInfo(context.getters.schoolId, context.getters.billingOptionId);
            context.commit(Mutations.SET_BILLING_LIST, data);
        },

        async getBillingInvoices(context) {
            const { data } = await BillingInfoService.getInvoices(context.getters.schoolId);
            context.commit(Mutations.SET_BILLING_INVOICES, data);
        },

        async createBillingInfo(context, payload) {
            let stripeResponse;
            context.dispatch('showSpinner');
            try {
                if (payload.type === BILLING_TYPES[0]) {
                    stripeResponse = await BillingInfoService.createStripeTokenForCard({
                        ...payload.formCredit,
                        cardNumber: payload.cardNumber,
                        cardExpiry: payload.cardExpiry,
                        cardCvc: payload.cardCvc
                    });

                    if (stripeResponse.error) {
                        context.dispatch('createErrorNotification', 'Your Billing Details where rejected by Stripe');
                        throw stripeResponse.error;
                    }

                    await BillingInfoService.createSchoolBillingOption(context.getters.schoolId, {
                        sourceToken: stripeResponse.token.id,
                        type: payload.type.data,
                        defaultMethod: payload.defaultMethod
                    });
                }
                else {
                    await BillingInfoService.createSchoolBillingOption(context.getters.schoolId, {
                        sourceToken: payload.token,
                        accountId: payload.accountId,
                        type: payload.type,
                        defaultMethod: payload.defaultMethod
                    })
                }

                context.dispatch('createSuccessNotification', 'You’ve successfully added a new payment source');
                await context.dispatch('getBillingInfo');
                await context.dispatch('getTrialPeriodEndDate');
            } finally {
                context.dispatch('hideSpinner');
            }
        },

        async getBillingOption(context) {
            try {
                context.dispatch('showSpinner');
                const { data } = await BillingInfoService.getSchoolBillingOption(context.getters.schoolId, context.getters.billingOptionId);
                context.commit(Mutations.SET_BILLING_OPTION, data);
            } finally {
                context.dispatch('hideSpinner');
            }
        },

        async editBillingOption(context, form) {
            try {
                context.dispatch('showSpinner');
                // Extract month and year from the new format '1120'
                const expiryMonth = parseInt(form.expiryDate.substring(0, 2));
                const expiryYear = parseInt(form.expiryDate.substring(2));
                await BillingInfoService.editSchoolBillingOption(context.getters.schoolId, context.getters.billingOptionId, {
                    expiryMonth,
                    expiryYear,
                    defaultMethod: form.defaultMethod
                });
                await context.dispatch('getBillingInfo');
            } finally {
                context.dispatch('hideSpinner');
            }
        },

        async deleteBillingOption(context, id) {
            await BillingInfoService.deleteBillingOption(context.getters.schoolId, id);
            await context.dispatch('getBillingInfo');
        },

        prepareBillingOption(context, id) {
            context.commit(Mutations.SET_BILLING_OPTION_ID, id);
            context.dispatch('openModal', { modalName: 'EditBillingModal' });
            context.dispatch('getBillingOption');

        },

        async getInvoicePdfDownloadLink(context, invoiceId) {
            const { data } = await BillingInfoService.getInvoicePdfDownloadLink(context.getters.schoolId, invoiceId);
            return data;
        },

        async getInvoicePdf(context, invoiceId) {
            const url = await context.dispatch('getInvoicePdfDownloadLink', invoiceId);
            window.open(url, '_blank');
        }
    },

    getters: {
        cards: state => state.billingList && state.billingList.filter(el => el.type === BILLING_TYPES[0].data),

        bankAccounts: state => state.billingList && state.billingList.filter(el => el.type === BILLING_TYPES[1].data),

        billingOptionId: state => state.billingOptionId,

        billingInvoices: state => state.invoices && state.invoices.map(invoice => ({
            ...invoice,
            status: _.capitalize(invoice.status),
            periodStart: moment(invoice.periodStart).format('MMMM DD, YYYY'),
            periodEnd: moment(invoice.periodEnd).format('MMMM DD, YYYY')
        }))
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/billing-info/billing.module.js